var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.281,
    y1: -0.398,
    x2: 1.135,
    y2: 1.266,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae1260"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "github",
    transform: "translate(-653 -292)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 70,
    height: 70,
    transform: "translate(653 292)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H70V70Z",
    transform: "translate(653 292)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M11.1,27.827a1.151,1.151,0,0,0,.7-1.058v-3.11a2.967,2.967,0,0,1,.024-.351l-.024.006H9.719A2.075,2.075,0,0,1,7.76,22.276c-.4-.749-.576-2.016-1.613-2.707-.173-.115-.058-.288.288-.288A3.155,3.155,0,0,1,7.99,20.433a2.433,2.433,0,0,0,1.958,1.152,6.253,6.253,0,0,0,2.662-.32,2.745,2.745,0,0,1,2.061-1.408v-.014c-3.265-.1-5.351-1.19-6.322-2.866a34.764,34.764,0,0,0-5,.407q-.05-.283-.087-.569a35.288,35.288,0,0,1,4.81-.415,4.7,4.7,0,0,1-.168-.489,37.225,37.225,0,0,0-4.716.056c-.012-.191-.027-.382-.029-.575a37.74,37.74,0,0,1,4.619-.064,5.663,5.663,0,0,1-.075-.889,4.96,4.96,0,0,1,.979-2.88c-.288-.979-.691-3.053.115-3.8a4.8,4.8,0,0,1,3.168,1.21,8.537,8.537,0,0,1,3.283-.634,8.052,8.052,0,0,1,3.226.634,4.8,4.8,0,0,1,3.168-1.21c.864.806.4,2.88.115,3.8a4.42,4.42,0,0,1,.922,2.88,5.745,5.745,0,0,1-.063.812,38.051,38.051,0,0,1,4.726.059c0,.194-.019.384-.029.575a37.319,37.319,0,0,0-4.815-.051,4.766,4.766,0,0,1-.187.565,35.8,35.8,0,0,1,4.924.4q-.037.287-.087.569a35.1,35.1,0,0,0-5.115-.393c-.959,1.658-3.007,2.739-6.208,2.865v.018c1.5,0,2.88,2.247,2.88,3.8v3.111a1.151,1.151,0,0,0,.7,1.058,13.249,13.249,0,1,0-8.305,0Z",
    transform: "translate(687 298)",
    fill: "#f1eaea"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.966912b120df4ba44a1d5ba68a29761c.svg";
export { ForwardRef as ReactComponent };